/**
 * MEMBERSHIP dept-filter for admin catalog LIST views (B5 bug 3).
 *
 * This is the "what's actually attached to this department" semantic — distinct
 * from the VISIBILITY union (tagged ∪ org-wide) used by consumption pickers.
 * Selecting a department shows ONLY rows tagged to it (org-wide/untagged rows do
 * NOT appear under a specific dept); the explicit "Org-wide" option shows ONLY
 * untagged rows; the empty ("All departments") filter shows everything.
 *
 * Single source of truth for the 5 catalog list filters (Bed / OT / Surgery /
 * Procedure / Lab) so the membership rule can't drift between them.
 */
export const ORG_WIDE_FILTER = '__org_wide__';

export function filterByDeptMembership(rows, deptFilter) {
  if (!deptFilter) return rows;
  if (deptFilter === ORG_WIDE_FILTER) {
    return rows.filter((r) => (r.department_ids || []).length === 0);
  }
  return rows.filter((r) => (r.department_ids || []).includes(deptFilter));
}
